<div class="mode-toggle" role="tablist" aria-label="UI mode switch">
  <div class="mode-toggle__track">
    <span class="mode-toggle__pill" [class.mode-toggle__pill--right]="mode.isLearner()" aria-hidden="true"> </span>

    <button
      type="button"
      class="mode-toggle__btn"
      role="tab"
      [attr.aria-selected]="mode.isAdmin()"
      [class.mode-toggle__btn--active]="mode.isAdmin()"
      (click)="switch('admin')"
    >
      Admin view
    </button>

    <button
      type="button"
      class="mode-toggle__btn"
      role="tab"
      [attr.aria-selected]="mode.isLearner()"
      [class.mode-toggle__btn--active]="mode.isLearner()"
      (click)="switch('learner')"
    >
      Learner view
    </button>
  </div>
</div>
